import { useApiGet } from '../../common/api/Api.hooks';
import { OrganizationInfo } from './Organization.interface';

export function useGetOrganizationInfo() {
  const { data, get, ...result } = useApiGet<OrganizationInfo>('organizations');
  return { ...result, organizationInfo: data, getOrganizationInfo: get };
}
